import styled from "@emotion/styled";
import { IStyledComponentProps } from "../../theme/theme.types";
import { Container } from "react-bootstrap";

const GridContainer = styled(Container)<IStyledComponentProps>`
  &.grid-container {
    margin-top: 24px;
    min-height: 100%;
    height: 100%;

    &.projects-view {
      .page-controls-row {
        margin-top: 0;
        margin-bottom: 24px;
      }

      .content-row {
        height: 100%;
      }

      @media (max-width: ${({ theme }) =>
          theme.utils.getThemeBreakpoint("tablet")}) {
        padding-left: 12px;
        padding-right: 12px;
      }
    }

    &.details-view {
      @media (max-width: ${({ theme }) =>
          theme.utils.getThemeBreakpoint("tablet")}) {
        margin-left: 0;
        margin-right: 0;
        padding-left: 24px;
        padding-right: 24px;
      }
    }

    .col {
      padding-bottom: 24px;
      &.no-results-column {
        width: 100%;
        min-height: 210px;
        text-align: center;
        /*margin-top: 10%;*/
      }
    }
  }
`;

export default { GridContainer };
